import { render, staticRenderFns } from "./assignPickLocToUser.vue?vue&type=template&id=5b0fc772&"
import script from "./assignPickLocToUser.vue?vue&type=script&lang=js&"
export * from "./assignPickLocToUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports